import { Colors } from "veneer/Theme";

// Mapbox expressions

export const GET_POINT_COUNT = ["get", "point_count"];
export const GET_MARKER_COLOR = ["get", "markerColor"];

// Color mapping

export const COLORS = {
  darkYellow: Colors.yellow800,
  black: Colors.black,
  gray: Colors.gray700,
  green: Colors.green700,
  orange: Colors.orange600,
  red: Colors.red700,
  white: Colors.white,
  yellow: Colors.yellow700,
};

// Clusters

export const MAX_CLUSTER_ZOOM = 14;

export const CLUSTER_RADIUS_STEPS: any = [
  "step",
  GET_POINT_COUNT,
  15,
  5,
  18,
  10,
  20,
];

export const CLUSTER_STROKE_WIDTH = 6;

export const CLUSTER_EXPAND_ZOOM_THRESHOLD = 10;
export const CLUSTER_LEAVES_PAGE_SIZE = 100;
export const CLUSTER_LEAVES_OFFSET = 0;

export const CLUSTER_FIT_MAX_ZOOM = 18;
export const CLUSTER_FIT_PADDING = 20;
export const CLUSTER_FIT_DURATION_MS = 1000;

// Map defaults

export const INITIAL_CENTER: [number, number] = [-75.17917, 39.965033];
export const INITIAL_ZOOM = 8;
export const LAT_LIMIT = 90;
export const LNG_LIMIT = 180;
export const MAX_ZOOM = 20;
export const MIN_ZOOM = 1;

// Spiderfy geometry

export const SPIRAL_ANGLE_STEP = Math.PI / 8;
export const CIRCLE_RADIUS = 0.0001;
